import { NgModule } from '@angular/core';
import { UIFormCheckbox, UIFormInput, UIFormSelect } from './components';
import { UIForm } from './form.component';
import { UIFormTime } from './components/form-time/form-time.component';
import { GetFormControlPipe } from './get-form-control.pipe';

@NgModule({
  imports: [UIForm, UIFormInput, UIFormSelect, UIFormCheckbox, UIFormTime, GetFormControlPipe],
  exports: [UIForm, UIFormInput, UIFormSelect, UIFormCheckbox, UIFormTime, GetFormControlPipe],
})
export class UIFormModule {}
